import { render, staticRenderFns } from "./FavoritePersons.vue?vue&type=template&id=77ece96d&"
import script from "./FavoritePersons.vue?vue&type=script&lang=js&"
export * from "./FavoritePersons.vue?vue&type=script&lang=js&"
import style0 from "./FavoritePersons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports